import { Planet, PlanetClassType, PlanetStage } from '@apeiron/planet'
import { NextImage } from '@apeiron/temp'
import { ApeironSimpleButton } from '@apeiron/ui'
import { Box, styled, Typography } from '@mui/material'
import BackgroundSVG from '@public/images/image-season-avatar-button.svg'
import SeasonAvatarPopup from '@src/components/planet/detail/seasonChange/SeasonAvatarPopup'
import { FC, useCallback, useMemo, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

const Container = styled(Box)`
  align-items: center;
  background-color: #ffffff05;
  border: 1px solid #838383;
  display: flex;
  gap: 10px;
  margin-top: 20px;
  padding: 10px 20px;
  width: 100%;

  ${props => props.theme.breakpoints.up('res1280')} {
    height: 100px;
  }
  ${props => props.theme.breakpoints.down('res1280')} {
    flex-direction: column;
    height: auto;
  }
`

const Description = styled(Typography)`
  flex: 1;
  font-size: 14px;
  strong {
    color: #f1b535;
  }
`

const Button = styled(ApeironSimpleButton)`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 0px;
  ${props => props.theme.breakpoints.up('res1280')} {
    width: 200px;
  }
  ${props => props.theme.breakpoints.down('res1280')} {
    width: 100%;
    max-width: 200px;
  }
  &:hover {
    filter: brightness(1.05);
  }
`

const Background = styled(NextImage)`
  aspect-ratio: 200 / 43;
  width: 100%;
`

const Text = styled(Typography)`
  position: absolute;
  color: black;
  font-weight: 700;
  font-size: 16px;
  text-shadow: 0px 2px 1px rgba(0, 0, 0, 0.2);
`

const SeasonSection: FC<Props> = props => {
  const { className, planet } = props

  const [isOpened, setIsOpened] = useState(false)

  const { t } = useTranslation()

  const handleOpen = useCallback(() => {
    setIsOpened(true)
  }, [])

  const handleClose = useCallback(() => {
    setIsOpened(false)
  }, [])

  // Per season we forcefully change the original planet into specific class
  const showSeasonMode =
    planet.stage === PlanetStage.Planet &&
    planet.planetClass === PlanetClassType.Fate // ? Fate > Fury for season 5

  const injectedPlanet = useMemo(() => {
    return {
      ...planet,
      image: planet.image
        ? planet.image.replace(/(_\d_)/, `_${PlanetClassType.Fury}_`)
        : null,
      planetClass: PlanetClassType.Fury // ? Fate > Fury for season 5
    }
  }, [planet])

  return showSeasonMode ? (
    <>
      <Container className={className}>
        <Description>
          <Trans>{t('planet.detail.s5_description')}</Trans>
        </Description>
        <Button onClick={handleOpen}>
          <Background src={BackgroundSVG} />
          <Text>{t('planet.detail.s5_button')}</Text>
        </Button>
      </Container>
      <SeasonAvatarPopup
        planet={injectedPlanet}
        open={isOpened}
        onClose={handleClose}
      />
    </>
  ) : null
}

type Props = {
  className?: string
  planet: Planet
}

export default SeasonSection
